import React, {useState, useEffect, useContext} from 'react';
import axios from 'axios';
import moment from 'moment';
import { useLocalStorage, useDebounce } from 'react-use';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import ReactDatetime from "react-datetime";
import useNotif from 'hooks/use-notify-hook';
import PlanContext from './Utils/context.js';
import { ACTIONS } from './Utils/action.js';
import {
  Button,
  Card,
  Col,
  Form,
  Row,
} from 'react-bootstrap';

import 'react-bootstrap-typeahead/css/Typeahead.css';

export default function AnswerAction({action}) {

  const context = useContext(PlanContext);
  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [members, setMembers] = useState(action?.pics ?? []);

  const [actionType, setActionType] = useState(action.ACTION_TYPE_ID || -1);
  const [description, setDescription] = useState(action.PLAN_DESC ?? ``);
  const [dueDate, setDueDate] = useState(action?.DUE_DATE ? moment(action.DUE_DATE, 'DD-MMM-YYYY').format('MM/DD/YYYY') : ``);


  const handleDeleteAction = async () => {

    try {

      const confiration = confirm('Are you sure?');
      if (!confiration) return;

      const response = await axios.delete(
        `${process.env.REACT_APP_API_HOST}answer-actions/${action.ANSWER_ACTION_ID}`,
        {headers: {Authorization: `Bearer ${auth.token}`}}
      );


      context.dispatchActions({
        type: ACTIONS.DELETE,
        payload: action.ANSWER_ACTION_ID,
      });

      dispatchNotif({
        place: `br`,
        message: `Delete Success...`,
        type: `success`,
      });

    } catch (error) {
      console.error(error);
      alert(`error`)
    }

    context.dispatchActions({
      type: ACTIONS.DELETE,
      payload: {

      }
    })
  }


  const handleChangeActionType = async ({target: {value}}) => {

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}answer-actions/${action.ANSWER_ACTION_ID}`,
        {ACTION_TYPE_ID: value},
        { headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        }
      );

      setActionType(response.data.ACTION_TYPE_ID);

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

    } catch (error) {
      console.error(error);
      alert(`error`)
    }
  }


  const handleChangeDueDate = async (value) => {

    const prettyDate = value.format('YYYY-MM-DD');

    try {

      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}answer-actions/${action.ANSWER_ACTION_ID}`,
        {DUE_DATE: prettyDate},
        {headers: {Authorization: `Bearer ${auth.token}`}},
      );

      setDueDate(prettyDate);

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

    } catch (error) {
      console.error(error);
      alert('error');
    }
  }

  const handleSearch = async (query) => {

    try {

      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}auditee-teams`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
        params: {
          SCHEDULE_ID: context.scheduleId,
          search: query,
          all: true,
          expand: 'employee',
        }
      });

      setOptions(response.data.items);
      setIsLoading(false);

    } catch (error) {
      console.log(error);
      alert('error');
    }
  }

  const handleChangeMembers = async selected => {

    try {

      const removed = members.find(member => !selected.includes(member));
      const added = selected.find(item => !members.includes(item));

      if (added) {
        if (members.find(member => member.EMP_ID === added.EMP_ID)) {
          return dispatchNotif({
            place: `br`,
            message: `Auditee Team Member already set.`,
            type: `danger`,
          });
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_HOST}pics`,
          {ANSWER_ACTION_ID: action.ANSWER_ACTION_ID, EMP_ID: added.EMP_ID},
          {
            headers: {Authorization: `Bearer ${auth.token}`},
            params: {expand: 'employee.user'},
          }
        );

        dispatchNotif({
          place: `br`,
          message: `Update Success...`,
          type: `success`,
        });

        return setMembers([...members, { ...response.data }]);
      }

      if (removed) {

        const response = await axios.delete(`
          ${process.env.REACT_APP_API_HOST}pics/${removed.PIC_ID}`,
          {headers: {Authorization: `Bearer ${auth.token}`}}
        );

        dispatchNotif({
          place: `br`,
          message: `Update Success...`,
          type: `success`,
        });

        return setMembers(selected);

      }

    } catch (error) {
      alert(`error`);
      console.log(error);
    }
  }

  const [, cancelDescription] = useDebounce(async () => {

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_HOST}answer-actions/${action.ANSWER_ACTION_ID}`,
        {PLAN_DESC: description},
        {headers: {Authorization: `Bearer ${auth.token}`}}
      );

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

    } catch (error) {
      console.error(error);
      // alert('error');
    }

  }, 2000, [description]);

  useEffect(() => {

    // cancelPlan();
    cancelDescription();
    setOptions(context.auditeeTeams);
  }, []);

  return (
    <Card>{notif}
      <Card.Body>
        <Row>
          <Col md="8">
            <Form.Group>
              <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Plan Description</Form.Label>
              <Form.Control
                value={description}
                onChange={({target: {value}}) => setDescription(value)}
                as="textarea"
                rows={5}
                isInvalid={description?.length > 4000}
              />
              <Form.Text id="passwordHelpBlock" muted>
                Total characters: {description?.length ?? 0} / 4000
              </Form.Text>
            </Form.Group>
          </Col>
          <Col md="4">
            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Tipe</Form.Label>
                  <Form.Control as="select"
                    value={actionType}
                    onChange={handleChangeActionType}
                  >
                    <option
                      disabled
                      value={-1}
                    >
                      Please select...
                    </option>
                    {context.actionTypes.map((type, key) => (
                      <option key={key} value={type.ACTION_TYPE_ID}>{type.ACTION_TYPE_NAME}</option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Due Date</Form.Label>
                  <ReactDatetime
                    value={dueDate}
                    inputProps={{
                      className: "form-control",
                      placeholder: "Date Picker Here",
                    }}
                    onChange={handleChangeDueDate}
                    timeFormat={false}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group>
              <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>PIC</Form.Label>
              <AsyncTypeahead
                multiple
                filterBy={() => true}
                id="async-example"
                // defaultSelected={auditeeTeams}
                isLoading={isLoading}
                labelKey={({ employee: { EMP_NAME }}) => EMP_NAME}
                minLength={1}
                onChange={handleChangeMembers}
                selected={members}
                onSearch={handleSearch}
                options={options}
                placeholder="Search for an employee..."
                renderMenuItemChildren={({ employee: { EMP_NAME, EMP_EMAIL }}) => (
                  <div>
                    {EMP_NAME}
                    <div>
                      <small>{EMP_EMAIL}</small>
                    </div>
                  </div>
                )}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Form.Group>
              <Button onClick={handleDeleteAction} variant="danger">Remove</Button>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}